import React from 'react'
import { Checkbox } from '@material-ui/core'
import objectPath from 'object-path'
import { isEmpty } from '../../../action/condition/State'
import { createTableStyle } from '../Action'
import { COLUMN_SETTING } from '../config'
import { getEditComponent, getRenderColumn } from '../action/Column'
import { checkTableColumnCondition } from '../action/Condition'
import { handleRowSelect } from '../action/SelectRow'
import { numberTheme, currencyTheme } from '../theme/InputTheme'
import { applyMaterialTableColumnType } from './TableColumnType'

export const createTableColumnHelper = ({
  uischema,
  tableColumnList,
  rowSelection,
  checkAll,
  handleRowSelectAll,
  propAction,
  formData,
  tabParamActive,
  designContext,
  tableData,
  setTableData,
  focus,
  setFocus,
  modalAction,
  setModalAction,
  isClickButton,
  setIsClickButton,
  columnRequire,
  setColumnRequire,
  tableRef,
  allParams,
  location,
  history,
  historyContext,
  formatDate,
  formatTime,
  formatDateTime,
  renderTableData,
  onOpenModalTable,
  setDetailColumns,
  setTableColumn,
}) => {
  const checkSelectedRow = (rowData) => {
    return rowSelection.find((select) => {
      if (objectPath.has(select, 'id') && objectPath.has(rowData, 'id')) {
        return select?.id === rowData?.id
      }
      if (
        objectPath.has(select, 'tableData.id') &&
        objectPath.has(rowData, 'tableData.id')
      ) {
        return select?.tableData?.id === rowData?.tableData?.id
      }
      let columnRefId = uischema?.loadData?.columnRefId
      if (columnRefId) {
        return (
          objectPath.get(select, columnRefId) ===
          objectPath.get(rowData, columnRefId)
        )
      }
    })
  }

  const createSelectionColumn = () => {
    let selectColumn = {
      title: (
        <>
          <Checkbox
            checked={checkAll}
            onChange={(e) => handleRowSelectAll(e.target.checked)}
          />{' '}
          เลือก
        </>
      ),
      field: 'rowSelection',
      render: (rowData) => (
        <Checkbox
          checked={checkSelectedRow(rowData)}
          onChange={(e) =>
            handleRowSelect(e.target.checked, rowData, propAction)
          }
        />
      ),
    }
    return createTableStyle(selectColumn, uischema)
  }

  const isHiddenColumn = (column, datasourceValue) => {
    let conditions = column?.conditions || []
    return conditions.find((condition) => {
      let { valueType, actionColumn, conditionCategory } = condition
      if (actionColumn !== 'hide') return false
      if (conditionCategory === 'table' && valueType !== 'tab') return false
      return checkTableColumnCondition({
        condition,
        column,
        formData,
        datasourceValue,
        tabParamActive,
        designContext,
      })
    })
  }

  const collectDetailColumn = (detailColumns, column, type) => {
    if (type === 'detailPanel') {
      objectPath.set(detailColumns, column.field, column.detailColumn)
      return true
    }
    if (type === 'html') {
      let formatType = objectPath.get(column, 'html.formatType')
      if (formatType === 'detail') {
        objectPath.set(detailColumns, column.field, column)
        return true
      }
    }
    return false
  }

  const getColumnRenderProps = (column, newColumnRequire) => {
    const stateParent = {
      tableData,
      setTableData,
      focus,
      setFocus,
      modalAction,
      setModalAction,
      isClickButton,
      setIsClickButton,
      columnRequire: newColumnRequire,
      setColumnRequire,
    }
    const defaultProp = {
      uischema,
      column,
      designContext,
      focus,
      tableRef,
      formData,
      allParams,
      location,
      history,
      historyContext,
    }
    const dateTimeProp = { formatDate, formatTime, formatDateTime }
    const actionProp = { renderTableData, onOpenModalTable }
    const themeProp = { numberTheme, currencyTheme }

    return { stateParent, defaultProp, dateTimeProp, actionProp, themeProp }
  }

  const applyColumnComponent = (column, type, newColumnRequire) => {
    const {
      stateParent,
      defaultProp,
      dateTimeProp,
      actionProp,
      themeProp,
    } = getColumnRenderProps(column, newColumnRequire)

    if (type && objectPath.get(COLUMN_SETTING, [type, 'editable'])) {
      column.editable = objectPath.get(COLUMN_SETTING, [type, 'editable'])
    }
    if (type && objectPath.get(COLUMN_SETTING, [type, 'editComponent'])) {
      column.editComponent = getEditComponent({
        defaultProp,
        dateTimeProp,
        stateParent,
        themeProp,
        actionProp,
      })
    }
    if (type && objectPath.get(COLUMN_SETTING, [type, 'render'])) {
      column.render = getRenderColumn({
        defaultProp,
        dateTimeProp,
        stateParent,
        themeProp,
        actionProp,
      })
    }
  }

  const applyRequiredColumn = (column, newColumnRequire) => {
    if (!column?.isRequired) return
    column.validate = (rowData) => {
      let value = objectPath.get(rowData, column.field)
      return isEmpty(value) ? { isValid: false } : true
    }
    if (!newColumnRequire.includes(column.field))
      newColumnRequire.push(column.field)
  }

  const applySortColumn = (column) => {
    if (column?.field === uischema?.sortField) {
      column.defaultSort = uischema.defaultSort || 'asc'
      column.sorting = true
    } else {
      delete column.defaultSort
    }
  }

  const createTableColumn = () => {
    if (!tableColumnList) return []
    let newColumn = []
    let newColumnRequire = [...columnRequire]

    if (uischema?.tableAction?.selection?.isActive) {
      newColumn = [createSelectionColumn()]
    }

    let filterColumn = tableColumnList.filter(
      ({ typeField }) => typeField !== 'system',
    )
    let newDetailColumns = {}
    let datasourceValue = objectPath.get(designContext, '@datasource')

    filterColumn.forEach((column, index) => {
      let type = column?.typeField || column?.type
      let valueType = column?.valueType
      if (valueType === 'element' && column?.receiveKey) {
        column.value = objectPath.get(formData, column.receiveKey)
      }
      if (isHiddenColumn(column, datasourceValue)) return
      if (collectDetailColumn(newDetailColumns, column, type)) return

      applyColumnComponent(column, type, newColumnRequire)
      if (column?.isLock) {
        column.editable = 'onAdd'
      }
      applyRequiredColumn(column, newColumnRequire)
      applySortColumn(column)
      column = applyMaterialTableColumnType(column, type)
      column = createTableStyle(column, uischema)
      objectPath.set(column, 'tableData.columnOrder', index)

      newColumn.push(column)
    })
    setDetailColumns(newDetailColumns)
    setTableColumn(newColumn)
    setColumnRequire(newColumnRequire)
  }

  return {
    createTableColumn,
  }
}
